import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight, ArrowLeft, Shield, Users, BadgeCheck } from "lucide-react";
import HavnsLogo from "../components/HavnsLogo";

const GetStarted = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FBF9F7] flex flex-col">
      {/* Header */}
      <header className="border-b border-[#EEE] bg-[#FBF9F7]/80 backdrop-blur-md">
        <div className="max-w-4xl mx-auto px-6 flex items-center justify-between h-20">
          <Button
            onClick={() => navigate("/")}
            variant="ghost"
            className="text-[#666] hover:text-[#1A1A1A]"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
          <HavnsLogo className="text-2xl" linkTo="/" />
          <div className="w-[72px]"></div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-md w-full text-center">
          <h1 className="font-serif text-4xl md:text-5xl text-[#1A1A1A] mb-4">
            Join the club
          </h1>
          <p className="text-[#666] text-lg mb-12">
            A private community for solo professionals seeking genuine connections.
          </p>

          {/* Trust Points */}
          <div className="space-y-4 mb-12 text-left">
            <div className="flex items-start gap-4 bg-white rounded-2xl p-5">
              <div className="w-10 h-10 rounded-full bg-[#E8F5E9] flex items-center justify-center flex-shrink-0">
                <BadgeCheck className="w-5 h-5 text-[#4CAF50]" />
              </div>
              <div>
                <h3 className="font-medium text-[#1A1A1A] mb-1">Verified Members</h3>
                <p className="text-[#666] text-sm">Every member is verified through Aadhaar KYC</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-2xl p-5">
              <div className="w-10 h-10 rounded-full bg-[#FFF3E0] flex items-center justify-center flex-shrink-0">
                <Shield className="w-5 h-5 text-[#FF9800]" />
              </div>
              <div>
                <h3 className="font-medium text-[#1A1A1A] mb-1">Strictly Platonic</h3>
                <p className="text-[#666] text-sm">Zero tolerance for romantic advances</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-2xl p-5">
              <div className="w-10 h-10 rounded-full bg-[#E3F2FD] flex items-center justify-center flex-shrink-0">
                <Users className="w-5 h-5 text-[#2196F3]" />
              </div>
              <div>
                <h3 className="font-medium text-[#1A1A1A] mb-1">High-Intent Network</h3>
                <p className="text-[#666] text-sm">Professionals seeking meaningful friendships</p>
              </div>
            </div>
          </div>

          <Button
            onClick={() => navigate("/profile-builder")}
            className="w-full bg-[#1A1A1A] text-white hover:bg-[#333] rounded-full px-10 py-8 text-lg"
            data-testid="create-profile-btn"
          >
            Create Your Profile
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>

          <p className="text-[#999] text-sm mt-6">
            By continuing, you agree to our{" "}
            <a href="/manifesto" className="underline">Anti-Dating Manifesto</a>
          </p>
        </div>
      </main>
    </div>
  );
};

export default GetStarted;
